import React from "react";

function Banner() {
  return (
    <div className="banner">
      <div className="banner--inner">
        <h1 className="banner--inner__title">Full-Stack Web Developer</h1>
        <p className="banner--inner__tagline">
          Welcome to my little piece of the internet! Always a work in progress
          and loving the journey.
        </p>
      </div>
    </div>
  );
}

export default Banner;
